(function () {
    angular.module('PWAPoCApp').controller('WeightBluetoothSensorModalController', weighBluetoothtSensorModalController);

    weighBluetoothtSensorModalController.$inject = ['$timeout', '$rootScope', '$scope', '$windowInstance', 'routeStop', 'botekSensorListener', 'appSettings', 'dataButton', 'commonUtil', 'routeStopsNearby',];

    function weighBluetoothtSensorModalController($timeout, $rootScope, $scope, $windowInstance, routeStop, botekSensorListener, appSettings, dataButton, commonUtil, routeStopsNearby,) {
       
        var botekWaitingMsg = $rootScope.translate('routeStopCard.weightSensorModal.waitingMsg');
        $scope.isManualMode = false;
        $scope.numbers = '';
        $rootScope.botekWeightValues = [];

        $scope.isRfid = $rootScope.botekSettings.enableBotekHyperionByRFIDGPS || $rootScope.botekSettings.enableBotekHyperionByRFID;
        $scope.files = getBotekFileValues($rootScope.botekFiles);
        $scope.getContainerName = getContainerName;
       
        initController();

        function initController() {
            $scope.isManualMode = false;
            $rootScope.$broadcast('showBusyIndicator', botekWaitingMsg);
            if (!$rootScope.isWeightSensorPollingCache)
            {
                startTryGetSensorValues();
                $rootScope.isWeightSensorPollingCache = true;
            }
        }

        $scope.setValue = function() {
            addWeightToUnits()
            botekSensorListener.stopListening();
            $windowInstance.close({ routeStop: routeStop, weight: $rootScope.botekSumWeight });
        };

        
        $scope.setManual = function (sensor) {
            if (!Number($rootScope.botekSumWeight)) {
                $rootScope.$broadcast('hideBusyIndicator');
                initManual();
                $scope.isManualMode = true;
            }
        }

        $scope.OkButtonEnabled = function() {
            return Number($rootScope.botekSumWeight);
        }
        $scope.ManualEnabled = ()=> {
            return !Number($rootScope.botekSumWeight);
        }

       function startTryGetSensorValues(){
            botekSensorListener.getSensorValues().then(weightValues =>{
                if (weightValues && weightValues.length) {
                    $rootScope.$broadcast('hideBusyIndicator');
                    $scope.botekWaitingMsg = null;
                    $rootScope.botekSumWeight = _.sum(_.map(weightValues, w=>Number(w))).toString();
                    $rootScope.botekWeightValues = weightValues;
                }else{
                    $scope.botekWaitingMsg = botekWaitingMsg;
                }
                if ($rootScope.isWeightSensorPollingCache)
                {
                    setTimeout(startTryGetSensorValues, appSettings.botekCheckInterval);
                }
            });
       }
       
        //manual input weight
        $scope.numbers = '';
        $scope.addComma = addComma;
        $scope.back = back;
        $scope.save = save;
        $scope.saveEnabled = () => Number($rootScope.botekSumWeight);

        function initManual() {
            if (dataButton.value) {
                $scope.numbers = dataButton.value.toString();
            }
        }

        function addComma() {
            if ($scope.numbers.indexOf(',') === -1) {
                $scope.numbers += ',';
            }
        }

        function back() {
            $scope.isManualMode = false;
            $rootScope.$broadcast('showBusyIndicator', botekWaitingMsg);
        }

        function save() {
            $rootScope.botekSumWeight = commonUtil.correctDataButtonValueFloatFormat($scope.numbers);
            $scope.setValue();
        }

        function getContainerName(rfid) {
            if (!routeStopsNearby || !Array.isArray(routeStopsNearby)) {
                return "";
            }

            for (const rs of routeStopsNearby) {
                if (rs.units && Array.isArray(rs.units)) {
                    const unit = rs.units.find(
                        (unit) => unit.labelId?.toString() === rfid.toString()
                    );
                    if (unit) {
                        return unit.name;
                    }
                }
            }

            return "";
        }

        function getBotekFileValues(files){
            if (!files) return [];
            const botekFileValues = files.map(file => {
                const objKeys = Object.keys(file);
                const fileName = objKeys[0];
                const weight = file[fileName].weight;
                const id = file[fileName].id;
                return {weight, id};
            });

            return botekFileValues || [];
        }
        
        function addWeightToUnits() {
            $scope.files.forEach(file => {
                routeStopsNearby.forEach(nearbyRouteStop => {
                    nearbyRouteStop.units.forEach(unit => {
                        if (unit.labelId.toString() === file.id.toString()) {
                            const formattedWeightValue = Number(commonUtil.correctDataButtonValueFloatFormat(file.weight).split(',').join('.')); //"0,0" -> "0" -> 0
                            unit.unitWeight = formattedWeightValue.toString();
                        }
                    });
                })
            })
        }
    }
})();
